import React from "react";

import BordaModal from "./components/BordaModal";
import PizzaTimer from "./components/PizzaTimer";
import PizzaSizeGrid from "./components/PizzaSizeGrid";

import { formatTime } from "./utils/timeUtils";
import { getPizzaIcon } from "./utils/pizzaUtils";

import { PizzaioloProvider, usePizzaiolo } from "./context/PizzaioloContext";

const PizzaioloContent: React.FC = () => {
  const {
    isModalOpen,
    showTimer,
    selectedPizza,
    selectedBorda,
    timeElapsed,
    bordas,
    isLoadingBordas,
    isCreatingProducao,
    isFinalizingProducao,
    handleCancel,
    handleConfirm,
    handleStop,
    setSelectedBorda,
  } = usePizzaiolo();

  return (
    <main className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
      <BordaModal
        isOpen={isModalOpen}
        selectedPizza={selectedPizza}
        bordas={bordas}
        isLoading={isLoadingBordas}
        isCreatingProducao={isCreatingProducao}
        selectedBorda={selectedBorda}
        onBordaSelect={setSelectedBorda}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />

      {showTimer ? (
        <div className="animate-fadeInUp px-4 pt-8">
          <PizzaTimer
            activeTimer={selectedPizza}
            timeElapsed={timeElapsed}
            isFinalizing={isFinalizingProducao}
            onStop={handleStop}
            getPizzaIcon={getPizzaIcon}
            formatTime={formatTime}
          />
        </div>
      ) : (
        <PizzaSizeGrid />
      )}
    </main>
  );
};

const Pizzaiolo: React.FC = () => {
  return (
    <PizzaioloProvider>
      <PizzaioloContent />
    </PizzaioloProvider>
  );
};

export default Pizzaiolo;
